import { UserAccess, UserAccessEnum } from "../models/user.access";

export class AuthService {
  private _currentUser: UserAccess = { userAccess: UserAccessEnum.FREEMIUM }

  get currentUser() {
    return this._currentUser
  }

  set currentUser(user: UserAccess) {
    this._currentUser = user
  }

  hasFullAccess(entity?: string, id?: string): boolean {
    return this.currentUser.userAccess !== UserAccessEnum.FREEMIUM
  }
}

export const authService = new AuthService()